import { identity } from 'lodash';

export function createUniqueName(
  name: string | MinLengthArray<1, string>,
  existingNames: string[],
  formatter: (name: string) => string = identity,
) {
  const nameArr = typeof name === 'string' ? [name] : name;
  let uniqueNumber = 1;
  let variableName = formatter(nameArr.shift() ?? '');
  while (existingNames.includes(variableName)) {
    if (nameArr.length > 1) {
      variableName = formatter(nameArr.shift() ?? '');
    } else {
      // increment the number until we find a name that doesn't exist
      uniqueNumber += 1;
      variableName = formatter(`${name} ${uniqueNumber}`);
    }
  }
  return variableName;
}
